<template>
  <div class="registration-wrapper">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-lg-10">
          <div class="card registration-card shadow-lg">
            <div class="card-body p-4 p-md-5">
              <div class="d-flex justify-content-between align-items-center mb-4">
                <h2 class="text-uppercase mb-0">
                  <i class="bi bi-person-plus-fill me-2"></i>
                  Cadastro de Cainita
                </h2>
                <span class="badge bg-danger-subtle text-uppercase text-danger">Novo</span>
              </div>

              <p class="text-muted mb-4">
                Preencha as informações abaixo para ingressar no domínio digital da Camarilla.
              </p>

              <form @submit.prevent="submit">
                <div class="row g-3">
                  <div class="col-md-6">
                    <label class="form-label">Nome completo *</label>
                    <input type="text" class="form-control" v-model="form.name" required>
                  </div>
                  <div class="col-md-6">
                    <label class="form-label">Apelido</label>
                    <input type="text" class="form-control" v-model="form.nickname">
                  </div>
                  <div class="col-md-6">
                    <label class="form-label">Email *</label>
                    <input type="email" class="form-control" v-model="form.email" @input="syncLogin" required>
                  </div>
                  <div class="col-md-6">
                    <label class="form-label">Login *</label>
                    <input type="email" class="form-control" v-model="form.login" readonly required>
                    <small class="text-muted">O login é definido automaticamente como o email.</small>
                  </div>
                  <div class="col-md-6">
                    <label class="form-label">Senha *</label>
                    <input type="password" class="form-control" v-model="form.password" @input="validatePassword" required>
                    <div class="password-feedback mt-2 small">
                      <div :class="passwordCriteria.length ? 'text-success' : 'text-muted'">
                        <i class="bi" :class="passwordCriteria.length ? 'bi-check-circle-fill' : 'bi-circle'"></i> Mínimo 8 caracteres
                      </div>
                      <div :class="passwordCriteria.uppercase ? 'text-success' : 'text-muted'">
                        <i class="bi" :class="passwordCriteria.uppercase ? 'bi-check-circle-fill' : 'bi-circle'"></i> Uma letra maiúscula
                      </div>
                      <div :class="passwordCriteria.lowercase ? 'text-success' : 'text-muted'">
                        <i class="bi" :class="passwordCriteria.lowercase ? 'bi-check-circle-fill' : 'bi-circle'"></i> Uma letra minúscula
                      </div>
                      <div :class="passwordCriteria.number ? 'text-success' : 'text-muted'">
                        <i class="bi" :class="passwordCriteria.number ? 'bi-check-circle-fill' : 'bi-circle'"></i> Um número
                      </div>
                      <div :class="passwordCriteria.special ? 'text-success' : 'text-muted'">
                        <i class="bi" :class="passwordCriteria.special ? 'bi-check-circle-fill' : 'bi-circle'"></i> Um caractere especial
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <label class="form-label">Hobbies</label>
                    <input type="text" class="form-control" v-model="form.hobbies"
                      placeholder="Coleção de artefatos, música clássica...">
                  </div>
                  <div class="col-12">
                    <label class="form-label">Descrição</label>
                    <textarea class="form-control" rows="3" v-model="form.description"
                      placeholder="Conte-nos um pouco sobre sua persona"></textarea>
                  </div>
                  <div class="col-md-6">
                    <label class="form-label">Foto de perfil (máx. 1 MB)</label>
                    <input type="file" class="form-control" accept="image/*" @change="handleFileChange">
                    <small class="text-muted">Formatos aceitos: JPG, PNG ou WEBP.</small>
                  </div>
                  <div class="col-md-6">
                    <label class="form-label">Convites de amizade</label>
                    <div class="alert alert-secondary mb-0 small">
                      Após se registrar, envie pedidos pelo seu perfil ou pela aba de chat. O outro usuário precisará aceitar
                      antes de aparecer na sua lista.
                    </div>
                  </div>
                </div>

                <div v-if="error" class="alert alert-danger mt-4">{{ error }}</div>
                <div v-if="success" class="alert alert-success mt-4">{{ success }}</div>

                <div class="d-flex justify-content-end mt-4">
                  <button type="submit" class="btn btn-vampire" :disabled="loading || !isPasswordValid">
                    <span v-if="loading" class="spinner-border spinner-border-sm me-2" role="status"
                      aria-hidden="true"></span>
                    <i v-else class="bi bi-check2-circle me-2"></i>
                    Registrar
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from '../services/api'
import { validatePassword, isPasswordSecure } from '../utils/validation'

export default {
  name: 'UserRegistration',
  data() {
    return {
      form: {
        name: '',
        email: '',
        nickname: '',
        login: '',
        password: '',
        description: '',
        hobbies: '',
        photo: null
      },
      passwordCriteria: {
        length: false,
        uppercase: false,
        lowercase: false,
        number: false,
        special: false
      },
      loading: false,
      error: '',
      success: ''
    }
  },
  computed: {
    isPasswordValid() {
      return isPasswordSecure(this.passwordCriteria)
    }
  },
  methods: {
    syncLogin() {
      this.form.login = this.form.email
    },
    validatePassword() {
      this.passwordCriteria = validatePassword(this.form.password)
    },
    handleFileChange(event) {
      const [file] = event.target.files
      if (file && file.size > 1024 * 1024) {
        this.error = 'A foto deve ter no máximo 1 MB.'
        event.target.value = ''
        return
      }
      this.form.photo = file || null
    },
    resetForm() {
      this.form = {
        name: '',
        email: '',
        nickname: '',
        login: '',
        password: '',
        description: '',
        hobbies: '',
        photo: null
      }
      this.passwordCriteria = {
        length: false,
        uppercase: false,
        lowercase: false,
        number: false,
        special: false
      }
    },
    async submit() {
      this.error = ''
      this.success = ''

      if (!this.form.name || !this.form.email || !this.form.login || !this.form.password) {
        this.error = 'Preencha todos os campos obrigatórios.'
        return
      }

      this.loading = true

      try {
        const formData = new FormData()
        formData.append('name', this.form.name)
        formData.append('email', this.form.email)
        formData.append('nickname', this.form.nickname)
        formData.append('login', this.form.login)
        formData.append('password', this.form.password)
        formData.append('description', this.form.description)
        formData.append('hobbies', this.form.hobbies)
        if (this.form.photo) {
          formData.append('photo', this.form.photo)
        }

        const { data } = await api.post('/users', formData, {
          headers: { 'Content-Type': 'multipart/form-data' }
        })

        this.success = 'Usuário cadastrado com sucesso!'
        this.$emit('registered', data.user)
        this.resetForm()
      } catch (error) {
        this.error = error.response?.data?.error || 'Não foi possível concluir o cadastro.'
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>
.registration-wrapper {
  padding: 2rem 0 3rem;
}

.registration-card {
  background: rgba(20, 20, 20, 0.92);
  border: 1px solid rgba(218, 165, 32, 0.2);
  color: #f8f9fa;
}

.registration-card .form-control,
.registration-card textarea {
  background-color: rgba(33, 33, 33, 0.85);
  border-color: rgba(139, 0, 0, 0.55);
  color: #f8f9fa;
}

.registration-card .form-control:focus,
.registration-card textarea:focus {
  border-color: var(--vampire-gold);
  box-shadow: 0 0 0 0.2rem rgba(218, 165, 32, 0.25);
}

.registration-card label {
  font-weight: 500;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  font-size: 0.85rem;
}

.btn-vampire {
  background: var(--vampire-red);
  color: #f8f9fa;
  border: none;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  padding: 0.75rem 2.5rem;
}

.btn-vampire:hover:not(:disabled) {
  background: var(--vampire-blood);
}

.btn-vampire:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.password-feedback {
  background: rgba(0, 0, 0, 0.2);
  padding: 0.5rem;
  border-radius: 4px;
}

.password-feedback .text-success {
  color: #2ecc71 !important;
}

.password-feedback .text-muted {
  color: #95a5a6 !important;
}

@media (max-width: 768px) {
  .registration-card {
    padding: 1rem;
  }
}
</style>
